import { Heading, Paragraph } from 'grommet'
import Image from 'next/image'
import styled, { css } from 'styled-components'

import { NormalizedWrapper } from '@theme'

export const Wrapper = styled(NormalizedWrapper)`
  ${({ theme }) => css`
    margin-top: ${theme.newSpaces.xl5}px;

    a {
      ${theme.getTypography('desktop', 'body', 'body2')}
    }

    ${theme.below.laptop`
      padding: 0 ${theme.newSpaces.sm}px;
      margin-top: ${theme.newSpaces.xl3}px;
    `}

    ${theme.below.mobileXL`
      padding: 0 ${theme.newSpaces.xl}px;
      margin-top: ${theme.newSpaces.xl}px;

      a {
        ${theme.getTypography('mobile', 'body', 'body3')}

        font-weight: ${theme.typography.mobile.body.body4.fontWeight};
      }
    `}
  `}
`

export const Subtitle = styled(Heading)`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title2')}

    color: ${theme.newColors.darkGray};
    margin-bottom: ${theme.newSpaces.xs}px;
    margin-top: ${theme.newSpaces.xs}px;

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'title', 'title3')}

      margin-top: ${theme.newSpaces.sm}px;
      margin-bottom: ${theme.newSpaces.xs}px;
      color: ${theme.newColors.darkGray};
    `}
  `}
`

export const Text = styled(Paragraph)`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'body', 'body2')}
    color: ${theme.newColors.darkGray};
    max-width: 100%;
    text-align: justify;
    white-space: pre-wrap;

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'body', 'body3')}

      font-weight: ${theme.typography.mobile.body.body4.fontWeight};
      text-align: start;
    `}
  `}
`

export const HexagonGray = styled(Image)`
  height: 360px;
  left: 0;
  position: absolute;
  width: auto;

  ${({ theme }) => css`
    top: ${theme.newSpaces.xl4}%;

    ${theme.below.laptop`
      display:none;
    `}
  `}
`

export const HexagonOrange = styled(Image)`
  height: 360px;
  position: absolute;
  right: 0;
  width: auto;

  ${({ theme }) => css`
    top: ${theme.newSpaces.lg}%;

    ${theme.below.laptop`
      display:none;
    `}
  `}
`
